const FULL_WIDTH_COMMA_PATTERN = /，/gu;
const INVALID_TAG_INPUT_CHARACTER_PATTERN = /[^\p{L}\p{N}\p{M}\s,]/gu;
const INVALID_TAG_VALUE_CHARACTER_PATTERN = /[^\p{L}\p{N}\p{M}\s]/gu;
const MULTIPLE_WHITESPACE_PATTERN = /\s+/gu;

export function sanitizeTagInput(value: string): string {
	return value.replace(FULL_WIDTH_COMMA_PATTERN, ',').replace(INVALID_TAG_INPUT_CHARACTER_PATTERN, '');
}

export function parseTagInput(value: string): string[] {
	return sanitizeTagInput(value)
		.split(',')
		.map(normalizeTagValue)
		.filter(Boolean);
}

export function formatTagList(values: string[]): string {
	return values.map(normalizeTagValue).filter(Boolean).join(', ');
}

export function hasInvalidTagValues(values: string[]): boolean {
	return values.some((value) => {
		const normalized = normalizeTagValue(value);
		return !normalized || normalized !== value.trim();
	});
}

function normalizeTagValue(value: string): string {
	return value.replace(INVALID_TAG_VALUE_CHARACTER_PATTERN, '').trim().replace(MULTIPLE_WHITESPACE_PATTERN, ' ');
}